/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompany } from './';
import {
    ClientCompanyFromJSON,
    ClientCompanyFromJSONTyped,
    ClientCompanyToJSON,
} from './';

/**
 * 
 * @export
 * @interface Client
 */
export interface Client {
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    identityId: string;
    /**
     * 
     * @type {ClientCompany}
     * @memberof Client
     */
    company: ClientCompany;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the Client interface.
 */
export function instanceOfClient(value: object): value is Client {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function ClientFromJSON(json: any): Client {
    return ClientFromJSONTyped(json, false);
}

export function ClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): Client {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'company': ClientCompanyFromJSON(json['company']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function ClientToJSON(value?: Client | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'company': ClientCompanyToJSON(value['company']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'fullName': value['fullName'],
        'photoUrl': value['photoUrl'],
    };
}

